const CONTAINER_ID = 'newsletter-preferences'
const ERROR_HTML = 'Het formulier kon niet worden verwerkt. Probeer het later opnieuw.'

const getCsrfToken = () => {
  const match = document.cookie.split('; ').find(row => row.startsWith('csrftoken='))
  return match ? decodeURIComponent(match.split('=')[1]) : ''
}

const queryParam = (url, name) => {
  try {
    return new URL(url, window.location.origin).searchParams.get(name)
  } catch {
    return null
  }
}

const selligentParam = (form, name) => queryParam(form.action, name) || queryParam(window.location.href, name) || form.querySelector(`[name="${name}"]`)?.value || ''

const buildPostUrl = form => {
  const postUrl = new URL(window.location.pathname, window.location.origin)
  const id = selligentParam(form, 'ID')
  const guid = selligentParam(form, 'GUID')

  if (id) {
    postUrl.searchParams.set('ID', id)
  }
  if (guid) {
    postUrl.searchParams.set('GUID', guid)
  }

  return postUrl.toString()
}

const bindSelligentPostForm = form => {
  if (form.dataset.selligentPostBound === 'true') {
    return
  }

  if (form.method.toLowerCase() !== 'post') {
    return
  }

  form.dataset.selligentPostBound = 'true'
  form.addEventListener('submit', async event => {
    event.preventDefault()

    if (form.dataset.selligentSubmitting === 'true') {
      return
    }

    form.dataset.selligentSubmitting = 'true'
    const container = document.getElementById(CONTAINER_ID)
    const body = new FormData(form)
    const id = selligentParam(form, 'ID')

    if (id && !body.get('ID')) {
      body.set('ID', id)
    }

    try {
      const response = await fetch(buildPostUrl(form), {
        method: 'POST',
        headers: {
          'X-CSRFToken': getCsrfToken(),
          'X-Requested-With': 'XMLHttpRequest',
        },
        body,
        credentials: 'same-origin',
      })
      const html = await response.text()

      if (container) {
        container.innerHTML = html
      }
    } catch {
      if (container) {
        container.innerHTML = ERROR_HTML
      }
    } finally {
      form.dataset.selligentSubmitting = 'false'
    }
  })
}

const bindFormsIn = container => {
  container.querySelectorAll('form').forEach(bindSelligentPostForm)
}

const initSelligentPostInterceptor = () => {
  const container = document.getElementById(CONTAINER_ID)

  if (!container) {
    return
  }

  bindFormsIn(container)

  const observer = new MutationObserver(() => bindFormsIn(container))
  observer.observe(container, { childList: true, subtree: true })
}

export default initSelligentPostInterceptor
